import { Nullable, GenericObject } from '@dxb-web-ui-framework/common/types';
import { isEmpty } from '@dxb-web-ui-framework/common/utils/Helper';

enum DataTransformerName {
  PARTIALLY_MASK_VALUE = 'partiallyMaskValue',
}

const formTitleDataTransformerHandler = (
  preloadedData: Nullable<string | number | GenericObject | null>,
  dataTransformer: Function,
) => {
  if (!preloadedData || isEmpty(preloadedData)) {
    return;
  }

  switch (dataTransformer.name) {
    case DataTransformerName.PARTIALLY_MASK_VALUE:
      return dataTransformer(preloadedData, 4);
    default:
      return;
  }
};

export { formTitleDataTransformerHandler };
